"use strict";

var PropTypes = require("prop-types");

var AccountActions = require("./AccountActions");
var AccountConstants = require("./AccountConstants");
var AccountFormHelper = require("./AccountFormHelper");
var AccountStore = require("./AccountStore");

var SimpleDropdownFromWizard = require("../commonComponents/SimpleDropdownFromWizard");

class OrganizationTypeSelector extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			disabled: false,
			selectedOrganizationType: props.initialValue || ""
		};

		this._onChange = this._onChange.bind(this);
	}

	handleOrganizationTypeSelected(event) {
		if (!event || !event.currentTarget) {
			return;
		}

		var selectedOrganizationType = event.currentTarget.value;
		var formParentId = AccountFormHelper.getParentFormId(this);

		AccountActions.setSelectedOrganizationType(formParentId, selectedOrganizationType);
	}

	_onChange() {
		if (this._isMounted) {
			var $formParent = AccountFormHelper.getParentForm(this);
			var formParentId = AccountFormHelper.getParentFormId(this);

			var parentFormIdForUpdateAllowed = formParentId;
			if ($formParent.length > 0) {
				// updateAllowed applies to this selector when inside the createAccountForm or when inside the eventRegistration component (could be within a createAccountForm or spouseInformation)
				var $parentFormForUpdateAllowed = $formParent.is("[data-component='createAccountForm']") ? $formParent : $formParent.closest("[data-component='eventRegistration']").find("[data-component='createAccountForm']");
				parentFormIdForUpdateAllowed = AccountFormHelper.getParentFormIdFromForm($parentFormForUpdateAllowed);
			}

			this.setState({
				disabled: formParentId ? AccountActions.getIsFormInputDisabled(parentFormIdForUpdateAllowed || formParentId) : false,
				selectedOrganizationType: AccountActions.getSelectedOrganizationType(formParentId) || ""
			});
		}
	}

	componentDidMount() {
		this._isMounted = true;

		var $formParent = AccountFormHelper.getParentForm(this);
		var formParentId = AccountFormHelper.getParentFormIdFromForm($formParent);
		var updateAllowed = true;

		if ($formParent.length > 0) {
			// updateAllowed applies to this selector when inside the createAccountForm or when inside the eventRegistration component (could be within a createAccountForm or spouseInformation)
			var $parentFormForUpdateAllowed = $formParent.is("[data-component='createAccountForm']") ? $formParent : $formParent.closest("[data-component='eventRegistration']").find("[data-component='createAccountForm']");
			updateAllowed = !$parentFormForUpdateAllowed.length || $parentFormForUpdateAllowed.is("[data-update-allowed]");
		}

		AccountActions.setSelectedOrganizationType(formParentId, this.state.selectedOrganizationType);
		AccountStore.addSpecificListener(AccountConstants.SET_SELECTED_ORGANIZATION_TYPE, this._onChange);
		AccountStore.addChangeListener(this._onChange);
		AccountActions.toggleInputStatus(formParentId, /*disabled*/ !updateAllowed);
	}

	componentWillUnmount() {
		AccountStore.removeChangeListener(this._onChange);
		AccountStore.removeSpecificListener(AccountConstants.SET_SELECTED_ORGANIZATION_TYPE, this._onChange);
		if (this.props.isDesignMode) {
			var $formParent = AccountFormHelper.getParentForm(this);
			var formParentId = AccountFormHelper.getParentFormIdFromForm($formParent);
			var updateAllowed = true;

			if ($formParent.length > 0) {
				updateAllowed = $formParent.is("[data-update-allowed]");
			}

			AccountActions.setSelectedOrganizationType(formParentId, null);
			AccountActions.toggleInputStatus(formParentId, /*disabled*/ !updateAllowed);
		}

		this._isMounted = false;
	}

	render() {
		return (
			<SimpleDropdownFromWizard
				{...this.props}
				config={this.props.organizationTypeConfig}
				configKey="availableTypes"
				disabled={this.state.disabled}
				initialValue={this.state.selectedOrganizationType}
				optionsClassName="organization-type"
				reactComponentName="OrganizationTypeSelector"
				selectClassName="organization-type-selector"
				selectNameAttribute="organizationType"
				thisArg={this}
				wizard={AccountStore.get("wizardOrganizationTypes")}
				wizardValuesKey="organizationTypeAccountCodeValues"
			/>
		);
	}
}

OrganizationTypeSelector.propTypes = {
	childClass: PropTypes.string,
	context: PropTypes.string,
	dataComponentId: PropTypes.string,
	dataNestedId: PropTypes.string,
	dataRepeatedId: PropTypes.string,
	isCustomTheme: PropTypes.bool,
	isDesignMode: PropTypes.bool,
	organizationTypeConfig: PropTypes.object,
	reactComponentCategory: PropTypes.string,
	required: PropTypes.bool,
	theme: PropTypes.string
};

module.exports = OrganizationTypeSelector;
